import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MtnaOverlineIconHeadingModule } from '@mtna/core-angular';

import { RdsVariableDistributionModule } from '../variable-distribution';
import { RdsVariableStatsComponent } from './variable-stats.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule, MtnaOverlineIconHeadingModule, RdsVariableDistributionModule],
  declarations: [RdsVariableStatsComponent],
  exports: [RdsVariableStatsComponent],
})
export class RdsVariableStatsModule {}
